import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import * as MatchAPI from '../api/match';
const keys = Object.keys(MatchAPI.OutcomeType);
const OutcomeTitle = ({ outcome }) => {
    if (keys.includes(outcome)) {
        return React.createElement(React.Fragment, null, I18nAPI.translate('common', `outcome-${outcome}`) || outcome);
    }
    else {
        return React.createElement(React.Fragment, null, outcome);
    }
};
export default OutcomeTitle;
//# sourceMappingURL=OutcomeTitle.js.map